import digitConverter from "./digitConverter";
import thConverter from "./thConverter";

const digit_th_converter = (number) => {
  return digitConverter(number) + thConverter(number);
};

export default digit_th_converter;
